import { get, isEmpty } from "lodash";

import isNullish from "./isNullish";

export const getFullName = (
  user = {},
  {
    fallback = "userName",
    fallbackValue = "",
    firstNameKey = "firstName",
    lastNameKey = "lastName",
  } = {}
) => {
  if (isNullish(user) || isEmpty(user)) return fallbackValue;

  const firstName = get(user, firstNameKey);
  const lastName = get(user, lastNameKey);

  return (
    `${firstName ?? ""} ${lastName ?? ""}`.trim() ||
    get(user, fallback, fallbackValue)
  );
};
